import {
	config,
	arrayify,
	randomizeInputIds
} from './helpers/mkto.js';

/* eslint-disable no-unused-vars, no-undef */
function sentimentStudyForms(mktoId = 1348) {
	let formEls = document.querySelectorAll(`[data-mkto-instance="${mktoId}"]`);
	if (!formEls.length) return;
	console.log('Sentiment study forms: ' + formEls.length);
	formEls = arrayify(formEls);

	MktoForms2.whenRendered(function(mktoForm) {
		if (mktoForm.getId() !== mktoId) return;
		randomizeInputIds(mktoForm);
	});

	let loadForm = MktoForms2.loadForm.bind(MktoForms2, config.path, config.munchkinId, mktoId);

	(function loadFormCb(formEls) {
		let formEl = formEls.shift();
		formEl.id = 'mktoForm_' + mktoId;

		loadForm(function(mktoForm) {
			formEl.id = '';
			let container = formEl.closest('[data-mkto-container]'),
				wrap = container.querySelector('[data-mkto-form-wrap]'),
				conf = container.querySelector('[data-mkto-conf]'),
				link = container.querySelector('[data-mkto-link]'),
				vals = {};
			vals.Sentiment_Study_PDF__c = link ? link.getAttribute('href') : '';
			vals.Sentiment_Study_Title__c = link ? link.getAttribute('title') : '';
			mktoForm.addHiddenFields(vals);
			// console.log(mktoForm.getValues());
			mktoForm.onSuccess(function(values, followUpUrl) {
				wrap.setAttribute('hidden', true);
				conf.removeAttribute('hidden');
				setTimeout(function () {
					link.click();
				}, 2500);
				// prevent redirect
				return false;
			});
			if (formEls.length) {
				loadFormCb(formEls);
			}
		});
	})(formEls);
}
sentimentStudyForms();
/* eslint-enable no-unused-vars, no-undef */

